import { useTranslation } from 'react-i18next';

import styles from './Terms.module.css';
import { Typography } from '../typography';

export function Terms() {
  const { t } = useTranslation();

  return (
    <div className={styles.terms}>
      <Typography sizes={['h6']}>{t('terms.heading')}</Typography>

      <ol>
        <li>{t('terms.list.1')}</li>
        <li>{t('terms.list.2')}</li>
        <li>{t('terms.list.3')}</li>
        <li>{t('terms.list.4')}</li>
      </ol>

      <Typography sizes={['bold']}>{t('terms.fee')}</Typography>
    </div>
  );
}
